import * as React from "react"
import { usePlp } from '~/contexts/PlpContext'
import { notBlank } from '~/utils/helpers'

import Tile from '~/components/tile/tile'

import { aria_btn, cta_link } from "~/styles/app.module.scss"
import { callouts } from "~/styles/shared/callouts.module.scss"
import * as styles from "~/styles/plp/plp.module.scss"
import * as gstyles from "~/styles/plp/plp_group.module.scss"


const CollGroup = ({ groupData, index, checkCount, tileIndxIds }) => {
  const { 
    collection, singPlTiles, currGrpId, flats, 
    allColors, setAllColors, mores, handleMore, 
    handleQuick
  } = usePlp()

  const { prods_grouped } = collection
  const { grp_default, shw_moreprods } = collection.rules || {}

  const { mid, products, data } = groupData

  const item = prods_grouped.find(x => x.mid === mid)
  const colorways = item.products.length
  const styles_text = `${products.length} product styles in ${colorways} color${colorways > 1 ? 's' : ''}.`
  let desc_text = notBlank(data.description) ? data.description : null
  if (singPlTiles) {
    desc_text = desc_text ? `${desc_text} ${styles_text}` : styles_text
  }

  let show_mores = !singPlTiles && !!grp_default && !currGrpId && !mores.includes(mid)
  if (shw_moreprods) show_mores = false
  show_mores = false
  
  const more_count = show_mores ? products.length - 6 : 0

  return (
    <>
      <div className={[gstyles.tile_group, styles.tile_group].join(' ')} tile-group="">
        <div className={gstyles.title}>{data.name.split('--')[0]}</div>
        {(singPlTiles && currGrpId && !allColors) ? (
          <div className={gstyles.copy}>
            {products.length} product styles in {colorways} color{colorways > 1 ? 's' : ''} 
            <button 
              type="button"
              className={[aria_btn, cta_link].join(' ')} 
              onClick={(e) => setAllColors(true)} style={{marginLeft: '0.5em', fontSize: '0.9em', verticalAlign: 'middle'}}
            >
              Show All
            </button>
          </div>
        ) : (
          <>
            {desc_text && (
              <div className={gstyles.copy} dangerouslySetInnerHTML={{ __html: desc_text}} />
            )}
          </>
        )}
        {(data.hasOwnProperty('callouts') && notBlank(data.callouts)) && (
          <div className={`${gstyles.callouts} ${callouts}`}>
            {data.callouts.map( call => 
              <div key={`${mid}${index}-${call}`} className={gstyles.callout}>
                {call}
              </div>
            )}
          </div>
        )}
      </div>
      {products.slice(0, show_mores ? 6 : products.length).map((grp_product, pind) => 
        <Tile 
          key={`${grp_product.handle}${pind}`} 
          product={grp_product} 
          tile_ind={pind} 
          is_plp={true} 
          flats={flats} 
          show={tileIndxIds.includes(grp_product.mid)} 
          handleQuick={handleQuick} 
        />
      )}
      {(show_mores && products.length > 6) && (
        <div className={gstyles.tile_more}>
          <button 
            type="button"
            className={aria_btn} 
            onClick={(e)=> handleMore(mid)}
          >
            View {more_count} More {data.name.split('--')[0]}
          </button>
        </div>
      )}
    </>
  )
};

export default CollGroup
